(function(){
  // Compte à rebours Black Friday
  document.querySelectorAll('[data-countdown]').forEach(function(el){
    var end=new Date(el.getAttribute('data-countdown')).getTime();
    if(isNaN(end))return;
    function pad(n){return String(n).padStart(2,'0')}
    function tick(){
      var d=Math.max(0,end-Date.now()),s=Math.floor(d/1000);
      el.querySelector('[data-d]').textContent=pad(Math.floor(s/86400));
      el.querySelector('[data-h]').textContent=pad(Math.floor(s%86400/3600));
      el.querySelector('[data-m]').textContent=pad(Math.floor(s%3600/60));
      el.querySelector('[data-s]').textContent=pad(s%60);
    }
    tick();setInterval(tick,1000);
  });
  // Galerie
  document.querySelectorAll('[data-thumb]').forEach(function(b){
    b.addEventListener('click',function(){
      var i=b.getAttribute('data-thumb');
      document.querySelectorAll('[data-slide]').forEach(function(s){s.classList.toggle('is-active',s.getAttribute('data-slide')===i)});
      document.querySelectorAll('[data-thumb]').forEach(function(t){t.classList.toggle('is-active',t===b)});
    });
  });
  // Photo selon l'offre choisie
  function showMedia(id){
    if(!id)return;
    var slide=document.querySelector('.gallery__slide[data-media-id="'+id+'"]');
    if(!slide)return;
    var i=slide.getAttribute('data-slide');
    document.querySelectorAll('[data-slide]').forEach(function(s){s.classList.toggle('is-active',s===slide)});
    document.querySelectorAll('[data-thumb]').forEach(function(t){t.classList.toggle('is-active',t.getAttribute('data-thumb')===i)});
  }
  document.querySelectorAll('.offer input[type=radio]').forEach(function(r){
    r.addEventListener('change',function(){showMedia(r.getAttribute('data-media-id'))});
  });
  var checked=document.querySelector('.offer input[type=radio]:checked');
  if(checked)showMedia(checked.getAttribute('data-media-id'));
  // Barre d'achat collante sur mobile
  var sticky=document.querySelector('.sticky-buy'),form=document.getElementById('buy-form');
  if(sticky&&form&&'IntersectionObserver' in window){
    new IntersectionObserver(function(e){sticky.classList.toggle('is-on',!e[0].isIntersecting&&e[0].boundingClientRect.top<0)}).observe(form);
  }
})();
